import { render, staticRenderFns } from "./settingsCostCenter.vue?vue&type=template&id=dfa96ce0&"
import script from "./settingsCostCenter.vue?vue&type=script&lang=js&"
export * from "./settingsCostCenter.vue?vue&type=script&lang=js&"
import style0 from "./settingsCostCenter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports